<template>
  <div class="card-header">
    <CardCategory v-if="card.category" :category="card.category" />
    <div class="card-header__heading">
      <AppHeading tag="h2" class="card-header__title" :text="card.title" />
    </div>
  </div>
</template>

<script>
// Components
import AppHeading from 'Ui/AppHeading'
import CardCategory from 'Components/CardCategory'

export default {
  components: {
    AppHeading,
    CardCategory,
  },
  props: {
    card: {
      type: Object,
      required: true,
    },
  },
}
</script>

<style scoped>
.card-header {
  display: flex;
  justify-content: flex-start;
  align-items: flex-start;
  flex-flow: column;
  gap: 10px;
  padding: 0;
  border-top-left-radius: 0;
  border-top-right-radius: 0;
  background: transparent;
}

.card-header.window {
  align-items: center;
  justify-content: space-between;
  flex-flow: row wrap;
  gap: 8px;
  padding: 0;
  width: 100%;
  border-top-left-radius: 8px;
  border-top-right-radius: 8px;
  background: #fff;
}

.card-header.window .card-category {
  font-size: 10px;
  line-height: 14px;
  letter-spacing: 3px;
  padding: 4px 10px;
  text-transform: uppercase;
  text-align: center;
}

.card-header__title {
  font-size: 17px;
  line-height: 20px;
  font-weight: 700;
}

.card-header.window .card-header__title {
  font-size: 24px;
  line-height: 35px;
}

.card-header__subtitle {
  font-size: 13px;
  line-height: 20px;
  color: var(--c-secondary);
  margin-top: 5px;
}

.card-header.window .card-header__subtitle {
  font-size: 16px;
  font-weight: 600;
  line-height: 20px;
}

@media (min-width: 769px) {
  .card-header.window {
    flex-flow: row nowrap;
    gap: 15px;
  }

  .card-header.window .card-header__heading {
    flex: 1;
  }

  .card-header.window .card-category {
    flex: 0 0 auto;
  }
}

@media (min-width: 680px) {
  .card-header.window > :first-child {
    order: 2;
  }
}

@media (max-width: 768px) {
  .card-header.window .card-header__title {
    font-size: 20px;
    line-height: 28px;
  }

  .card-header.window .card-category {
    font-size: 8px;
    line-height: 10px;
  }
}
</style>
